const backToTopButton = document.getElementById('back-to-top');
let isButtonVisible = false; // Track the visibility state of the button

// Listen for scroll events
window.addEventListener('scroll', () => {
  if (window.scrollY > 100) {
    // Show the button when scrolled down
    if (!isButtonVisible) {
      backToTopButton.style.display = 'block'; // Ensure the button is displayed
      backToTopButton.classList.remove('hide');
      backToTopButton.classList.add('show');
      isButtonVisible = true;
    }
  } else {
    // Hide the button when scrolled back up
    if (isButtonVisible) {
      backToTopButton.classList.remove('show');
      backToTopButton.classList.add('hide');
      isButtonVisible = false;
    }
  }
});

// Listen for animationend to handle display property
backToTopButton.addEventListener('animationend', (event) => {
  if (event.animationName === 'slide-out') {
    backToTopButton.style.display = 'none'; // Fully hide the button after sliding out
  }
});

// Scroll back to the top when the button is clicked
backToTopButton.addEventListener('click', (event) => {
  event.preventDefault(); // Prevent default anchor behavior
  window.scrollTo({ top: 0, behavior: 'smooth' });
});
